import { Component, OnInit, signal, inject, ChangeDetectionStrategy } from '@angular/core'
import { ApiService } from '@shared/services/api.service'
import { environment } from '@environments/environment'
import { AuthService } from '@shared/services/auth.service'
import { LoadingComponent } from '@shared/components/loading/loading.component'
import { FailureMessageComponent } from '../shared/failure-message/failure-message.component'
import { isPlatformBrowser } from '@angular/common'
import { PLATFORM_ID } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { ErrorMessageService } from '@shared/services/error-message.service'

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingComponent, FailureMessageComponent, TranslatePipe],
})
export class ErrorComponent implements OnInit {
  private platformId = inject(PLATFORM_ID)
  private auth = inject(AuthService)
  private errorMessageService = inject(ErrorMessageService)
  api = inject(ApiService)

  readonly link = signal('')
  readonly loading = signal(false)
  readonly loan = signal<any>(null)

  async ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return
    }

    if (this.auth.isAuthenticated()) {
      this.loading.set(true)
      try {
        const { loan } = await this.api.getActiveLoan()
        this.loan.set(loan)
        this.link.set(`${environment.appHost}/resume/${loan.guid_id}`)
      } catch (error) {
        this.errorMessageService.handleError(error, 'getActiveLoan')
      } finally {
        this.loading.set(false)
      }
    }
  }
}
